import passwordChange from "./passwordChange";

export default passwordChange;
